export enum AccountFunction {
  BILL_RECEIVER = 'BILL_RECEIVER',
  MARKETING_MANAGER = 'MARKETING_MANAGER',
  CEO = 'CEO',
  COO = 'COO',
  PROCESS_RESPONSIBLE = 'PROCESS_RESPONSIBLE',
  ENTRY_POINT = 'ENTRY_POINT',
  MARKETPLACE = 'MARKETPLACE',
  INVESTOR = 'INVESTOR',
}
